module.exports = __webpack_public_path__ + "img/98.502840fc.jpg";